module.exports = __webpack_public_path__ + "static/grafika6@2x-52c6f917dcaeb573b667cd1ba78d6d90.png";